import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { FormsItemContextMenuItemBase } from './forms-context-menu-base';
import { FormsComponent } from '../../../views/site/forms/forms.component';
import { Form } from '../form-builder/form.model';
import { CopyFormDialog } from '../../dialogs/copy-form/copy-form.dialog';
import { ExportStructureInstancesDialog } from '../../dialogs/export-structure/export-structure.dialog';
import { XmlFileFormatEnum } from '../../enums/xml-file-format.enum';
import { DisplayContentData, DisplayContentDialog, DisplayContentDialogInitData } from '../../dialogs/display-content/display-content.dialog';
import { TrashDeleteEvent } from '../../components/list-view/list-view-trash-config.model';
import { IListItem } from '../../interfaces/ilist-item.interface';

// Define menu classes.
export class OpenFormItemContextMenuData extends FormsItemContextMenuItemBase {
    public constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnOpenItemClick(eventData);
        let editParam = {
            'originalEvent': eventData,
            'item': this.contextItem//this.contextMenu.menuData.item
        };
        //this.doOnEdit(editParam);
        this.component.doOnEdit(editParam);
    }
}

export class CopyFormAsItemContextMenuData extends FormsItemContextMenuItemBase {
    public constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnCopyAsItemClick(eventData);
        // Process a "copy form as" dialogue.
        let contextMenuForm: Form = this.contextItem; //this.contextMenu.menuData.item;

        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = contextMenuForm;

        const dialogRef = this.component.Dialog.open(CopyFormDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(formCopy => {
            // Note:  the site copy is now performed in the dialog component class.
            if (formCopy != null) {
                // Add the copied form to my list of forms.
                let updatedFormCatalog = Object.assign([], this.component.FormCatalog);
                updatedFormCatalog.push(formCopy);

                //this.formCatalog.push(formCopy);
                //this.formCatalog = updatedFormCatalog;
                this.component.FormCatalog = updatedFormCatalog;
            }
        });
    }
}

export class FormsExportMenuDataBase extends FormsItemContextMenuItemBase {
    protected constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    // Public static method.
    public static createExportStructureDialogueRef(dialog: MatDialog, contextMenuForm: Form): MatDialogRef<ExportStructureInstancesDialog, any> {
        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = contextMenuForm;

        const dialogRef = dialog.open(ExportStructureInstancesDialog, dialogConfig);

        return (dialogRef);
    }

    // Helper methods.
    protected createExportStructureDialogueRef(): MatDialogRef<ExportStructureInstancesDialog, any> {
        let contextMenuForm: Form = this.contextItem;

        /*
        let dialogConfig: MatDialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.width = '500px';
        dialogConfig.data = contextMenuForm; 

        const dialogRef = this.component.Dialog.open(ExportStructureInstancesDialog, dialogConfig);
        */
        const dialogRef = FormsExportMenuDataBase.createExportStructureDialogueRef(this.component.Dialog, contextMenuForm);

        return (dialogRef);
    }
}

export class ExportFormDefinitionItemContextMenuData extends FormsExportMenuDataBase {
    public constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnExportFormDefinitionItemClick(eventData);
        // Process an export structure instances dialogue.
        const dialogRef = this.createExportStructureDialogueRef();
        let dialogInstance: ExportStructureInstancesDialog = dialogRef.componentInstance;
        dialogInstance.exportFormDefinitionOnly = true;
        dialogInstance.xmlFileFormat = XmlFileFormatEnum.SIMPLIFIED_MINIMALIST_FORMAT;

        dialogRef.afterClosed().subscribe(exportedFormId => {
            // Note:  the export is performed in the dialog component class.
            if ((exportedFormId != null) && (exportedFormId > 0)) {
                // Anything left to do here?  Nope!
            }
        });
    }
}

export class ExportAllFormCopiesItemContextMenuData extends FormsExportMenuDataBase {
    public constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnExportAllCopiesItemClick(eventData);
        const dialogRef = this.createExportStructureDialogueRef();
        let dialogInstance: ExportStructureInstancesDialog = dialogRef.componentInstance;
        dialogInstance.xmlFileFormat = XmlFileFormatEnum.SIMPLIFIED_MINIMALIST_FORMAT;

        dialogRef.afterClosed().subscribe(exportedFormId => {
            // Note:  the export is performed in the dialog component class.
            if ((exportedFormId != null) && (exportedFormId > 0)) {
                // Anything left to do here?  Nope!
            }
        });
    }
}

export class ShowFormImportFormatsItemContextMenuData extends FormsItemContextMenuItemBase {
    public constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnShowImportFormatExampleItemClick(eventData);
        // Request an example of the import format for the selected form.
        let contextMenuForm: Form = this.contextItem;//this.contextMenu.menuData.item;

        this.component.FormBuilderService.getImportFormatExample(contextMenuForm.id).then(responseData => {
            //let initData: DisplayContentDialogInitData = new DisplayContentDialogInitData();
            //initData.title = 'Import Format Example';
            //initData.content = responseString;
            let contentData: DisplayContentData[] =
                [
                    { content: responseData.xmlFormatExample, tabName: 'Xml Format', makeContentReadonly: true },
                    { content: responseData.jsonFormatExample, tabName: 'Json Format', makeContentReadonly: true }
                ];
            //initData.contentData = contentData;
            //initData.contentLabel = 'Import Format Example';
            let initData: DisplayContentDialogInitData = new DisplayContentDialogInitData('Import Format Examples', contentData);

            let dialogConfig: MatDialogConfig = new MatDialogConfig();
            dialogConfig.hasBackdrop = true;
            dialogConfig.width = '500px';
            dialogConfig.height = '615px';
            dialogConfig.data = initData;

            const dialogRef = this.component.Dialog.open(DisplayContentDialog, dialogConfig);
            dialogRef.afterClosed().subscribe(na => {
            });
        });
    }
}

export class DeleteFormItemContextMenuData extends FormsItemContextMenuItemBase {
    public constructor(itemTitle: string, component: FormsComponent) {
        super(itemTitle, component);
    }

    public menuItemSelected(contextItem: any, eventData: any): void {
        //this.component.doOnDeleteItemClick(eventData);
        let doOnItemDeleteParam: TrashDeleteEvent =
            //new TrashDeleteEvent(eventData, [this.contextMenu.menuData.item] as IListItem[]);
            new TrashDeleteEvent(eventData, [this.contextItem] as IListItem[]);
        this.component.doOnItemDelete(doOnItemDeleteParam);
    }
}
